import React, { useCallback, useState } from 'react'
import { QueryFunctionContext, useQuery } from 'react-query'

import { Select, SelectProps } from './Select.component'

export type AsyncSelectProps = Omit<SelectProps, 'options' | 'isLoading' | 'onInputChange'> & {
  cacheKeyFn: (inputValue: string) => string
  promiseFn: (inputValue: string) => Promise<any[]>
}

export function AsyncSelect({ cacheKeyFn, promiseFn, ...selectProps }: AsyncSelectProps) {
  const [query, setQuery] = useState('')
  const cacheKey = cacheKeyFn(query)
  const { status, data = [] } = useQuery(cacheKey, ({ queryKey }: QueryFunctionContext<string>) => promiseFn(queryKey))
  const loading = status === 'loading'
  const handleInputChange = useCallback((inputValue: string) => {
    setQuery(inputValue)
  }, [])
  return <Select options={data} isLoading={loading} onInputChange={handleInputChange} {...selectProps} />
}
